import './style.scss';
import { useTranslation } from 'react-i18next';

import { FileUpload } from 'primereact/fileupload';
import { classNames } from 'primereact/utils';

import PropTypes from 'prop-types';
import { toast } from 'layout';
import { TOAST } from 'constant';

export default function CustomFileUpload({
  label,
  name,
  isRequired,
  disabled,
  accept,
  acceptFileMessage,
  isFontWeightLabel,
  acceptOnly,
  innerRef,
  maxFileSize,
  onUpload,
}) {
  const { t } = useTranslation();

  const uploadHandler = async (event) => {
    const fileName = event.files[0]?.name;
    let fileExt = fileName?.split('.').pop();
    fileExt = fileExt === fileName ? '' : `.${fileExt}`;

    if (accept !== '*') {
      const acceptExts = accept?.split(',');
      if (!acceptExts.includes(fileExt)) {
        toast(TOAST.ERROR, acceptFileMessage);
        return;
      }
    }

    const file = new File([event.files[0]], fileName, {
      type: event.files[0].type,
    });

    onUpload(file);
  };

  return (
    <div className="field">
      <label htmlFor={name} style={isFontWeightLabel ? { fontWeight: 900 } : {}}>
        {label}{' '}
        {isRequired && (
          <span className="text-red-500" style={{ fontWeight: 900 }}>
            *
          </span>
        )}
      </label>

      <FileUpload
        ref={innerRef}
        name={name}
        accept={accept}
        maxFileSize={maxFileSize}
        invalidFileSizeMessageDetail={t('errorMessage.invalidFileSizeMessageDetail', {
          maxFileSize: maxFileSize / 1000000,
        })}
        invalidFileSizeMessageSummary={t('errorMessage.invalidFileSizeMessageSummary')}
        emptyTemplate={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <p className="m-0">
            {t('formControl.fileInput')}{' '}
            <span className="text-red-500">
              {acceptOnly ? `(${t(`formControl.${acceptOnly}`)})` : ''}
            </span>
          </p>
        }
        chooseLabel={t('formControl.fileBrowse')}
        customUpload
        uploadHandler={(event) => {
          uploadHandler(event);
        }}
        className={classNames({
          'surface-200': disabled,
          'border-red-500': true,
        })}
        disabled={disabled}
        auto
      />
    </div>
  );
}

CustomFileUpload.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
  acceptFileMessage: PropTypes.string,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  isFontWeightLabel: PropTypes.bool,
  acceptOnly: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  maxFileSize: PropTypes.number,
  onUpload: PropTypes.func,
};

CustomFileUpload.defaultProps = {
  label: '',
  name: '',
  isRequired: false,
  disabled: false,
  accept: '*',
  isFontWeightLabel: false,
  acceptFileMessage: '',
  acceptOnly: '',
  innerRef: null,
  maxFileSize: 100000000,
  onUpload: () => {},
};
